import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import { makeStyles } from "@material-ui/core/styles";
import UserPermission from "../UserPermission";

/*Ícones*/
import { ReactComponent as DashboardIcon } from "../../assets/sidebar/icons/dashboard.svg";
import { ReactComponent as MapIcon } from "../../assets/sidebar/icons/map.svg";
import { ReactComponent as AboutIcon } from "../../assets/sidebar/icons/about.svg";
import { ReactComponent as ManualIcon } from "../../assets/sidebar/icons/manual.svg";
import { ReactComponent as OccurrencesIcon } from "../../assets/sidebar/icons/occurrences.svg";
import { ReactComponent as RegistersIcon } from "../../assets/sidebar/icons/registers.svg";
import { ReactComponent as ReportIcon } from "../../assets/sidebar/icons/report.svg";
import { ReactComponent as HistoryIcon } from "../../assets/sidebar/icons/history.svg";

import EngineeringIcon from "@mui/icons-material/Engineering";
import { SvgIcon } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 320,
    backgroundColor: theme.palette.background.paper,
  },

  nested: {
    paddingLeft: theme.spacing(8),
    color: "#155BCB",
  },
}));

export default function ListItems({ closeSidebarIfMobile }) {
  const classes = useStyles();
  const userPermission = UserPermission();
  const navigate = useNavigate();

  function ListItemLink(props) {
    return <ListItem button component="a" {...props} />;
  }

  const [openGerenciamento, setOpenGerenciamento] = useState(false);
  const [openOcorrencias, setOpenOcorrencias] = useState(false);
  const [openOcorrenciasInternas, setOpenOcorrenciasInternas] = useState(false);
  const [openLogs, setOpenLogs] = useState(false);
  const [openDashboard, setOpenDashboard] = useState(false);
  const [openFilterReports, setOpenFilterReports] = useState(false);
  const [openMap, setOpenMap] = useState(false);

  const redirectTo = (to, options = {}) => {
    closeSidebarIfMobile();
    navigate(to, options);
  };

  function closeAll() {
    setOpenDashboard(false);
    setOpenGerenciamento(false);
    setOpenOcorrencias(false);
    setOpenOcorrenciasInternas(false);
    setOpenFilterReports(false);
    setOpenLogs(false);
    setOpenMap(false);
  }

  function handleClickLogs() {
    closeAll();
    setOpenLogs(!openLogs);
  }

  function handleClickDashboard() {
    closeAll();
    setOpenDashboard(!openDashboard);
  }

  function handleClickGerenciamento() {
    closeAll();
    setOpenGerenciamento(!openGerenciamento);
  }

  function handleClickOcorrencias() {
    closeAll();
    setOpenOcorrencias(!openOcorrencias);
  }

  function handleClickOcorrenciasInternas() {
    closeAll();
    setOpenOcorrenciasInternas(!openOcorrenciasInternas);
  }

  function handleClickFilterReports() {
    closeAll();
    setOpenFilterReports(!openFilterReports);
  }
  
  function handleClickMap() {
    closeAll();
    setOpenMap(!openMap);
  }

  function handleClickFilter(value) {
    redirectTo("/reports-filters", {
      state: {
        typeFilter: value,
      },
    });
  }

  const Item = ({ Icon, text, width, height }) => {
    return (
      <>
        <SvgIcon>
          <Icon width={width} height={height} />
        </SvgIcon>
        <span
          style={{ color: "#155BCB", marginLeft: 10, fontFamily: "Rawline" }}
        >
          {text}
        </span>
      </>
    );
  };

  /* Itens que usam ícones do MUI, e não os svg da pasta de assets */
  const ItemMuiIcon = ({ Icon, text }) => {
    return (
      <>
        <Icon style={{ color: "#155BCB", fontSize: 22, verticalAlign: "middle" }} />
        <span
          style={{ color: "#155BCB", marginLeft: 10, fontFamily: "Rawline" }}
        >
          {text}
        </span>
      </>
    );
  };

  const renderIconExpand = (isExpanded) => {
    if (isExpanded) return <ExpandLess style={{ color: "#155BCB" }} />;
    else return <ExpandMore style={{ color: "#155BCB" }} />;
  };

  return (
    <div>
      <ListItem button onClick={handleClickDashboard}>
        <ListItemText
          primary={
            <Item
              width={24}
              height={24}
              Icon={DashboardIcon}
              text="Dashboard"
            />
          }
        />
        {renderIconExpand(openDashboard)}
      </ListItem>

      <Collapse in={openDashboard} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemLink
            button
            onClick={() => {
              redirectTo("/dashboard");
            }}
            className={classes.nested}
          >
            <ListItemText primary="Dashboard 1" />
          </ListItemLink>

          <ListItemLink
            button
            onClick={() => {
              redirectTo("/dashboard2");
            }}
            className={classes.nested}
          >
            <ListItemText primary="Dashboard 2" />
          </ListItemLink>
        </List>
      </Collapse>

      <ListItem button onClick={handleClickMap}>
        <ListItemText
          primary={
            <Item
              width={24}
              height={24}
              Icon={MapIcon}
              text="Mapas"
            />
          }
        />
        {renderIconExpand(openMap)}
      </ListItem>

      <Collapse in={openMap} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemLink
            button
            onClick={() => {
              redirectTo("/map");
            }}
            className={classes.nested}
          >
            <ListItemText primary="Mapa de Ocorrências" />
          </ListItemLink>

          <ListItemLink
            button
            onClick={() => {
              redirectTo("/map2");
            }}
            className={classes.nested}
          >
            <ListItemText primary="Mapa de Satisfação" />
          </ListItemLink>
        </List>
      </Collapse>


      <ListItem button onClick={handleClickOcorrencias}>
        <ListItemText
          primary={
            <Item
              width={22}
              height={22}
              Icon={OccurrencesIcon}
              text="Ocorrências"
            />
          }
        />
        {renderIconExpand(openOcorrencias)}
      </ListItem>

      <Collapse in={openOcorrencias} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemLink
            button
            onClick={() => {
              redirectTo("/search");
            }}
            className={classes.nested}
          >
            <ListItemText primary="Ocorrências em Aberto" />
          </ListItemLink>

          {userPermission === "admin" || userPermission === "manager" ? (
            <>
              <ListItemLink
                button
                onClick={() => {
                  redirectTo("/no-location-complaints");
                }}
                className={classes.nested}
              >
                <ListItemText primary="Ocorrências sem localização" />
              </ListItemLink>

              <ListItemLink
                button
                onClick={() => {
                  redirectTo("/late-complaints");
                }}
                className={classes.nested}
              >
                <ListItemText primary="Ocorrências Atrasadas" />
              </ListItemLink>
            </>
          ) : (
            false
          )}

          <ListItemLink
            button
            onClick={() => {
              redirectTo("/resolved-complaints");
            }}
            className={classes.nested}
          >
            <ListItemText primary="Ocorrências Concluídas" />
          </ListItemLink>
        </List>
      </Collapse>

      {userPermission === "admin" || userPermission === "manager" ? (
        <>
          <ListItem button onClick={handleClickOcorrenciasInternas}>
            <ListItemText
              primary={
                <ItemMuiIcon
                  Icon={EngineeringIcon}
                  text="Ocorrências Internas"
                />
              }
            />
            {renderIconExpand(openOcorrenciasInternas)}
          </ListItem>

          <Collapse in={openOcorrenciasInternas} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemLink
                button
                onClick={() => {
                  redirectTo("/service-order-register");
                }}
                className={classes.nested}
              >
                <ListItemText primary="Registrar Ocorrência" />
              </ListItemLink>

              <ListItemLink
                button
                onClick={() => {
                  redirectTo("/my-service-orders");
                }}
                className={classes.nested}
              >
                <ListItemText primary="Minhas Ocorrências" />
              </ListItemLink>

              {userPermission === "admin" ? (
                <ListItemLink
                  button
                  onClick={() => {
                    redirectTo("/manage-service-orders");
                  }}
                  className={classes.nested}
                >
                  <ListItemText primary="Gerenciar Ocorrências" />
                </ListItemLink>
              ) : (
                false
              )}
            </List>
          </Collapse>
        </>
      ) : (
        false
      )}

      <ListItem button onClick={handleClickFilterReports}>
        <ListItemText
          primary={
            <Item
              width={22}
              height={22}
              Icon={ReportIcon}
              text="Relatórios de Ocorrências"
            />
          }
        />
        {renderIconExpand(openFilterReports)}
      </ListItem>

      <Collapse in={openFilterReports} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemLink
            button
            onClick={() => handleClickFilter("status")}
            className={classes.nested}
          >
            <ListItemText primary="Por Estado da Ocorrência" />
          </ListItemLink>

          <ListItemLink
            button
            onClick={() => handleClickFilter("atendidas")}
            className={classes.nested}
          >
            <ListItemText primary="Atendidas" />
          </ListItemLink>

          <ListItemLink
            button
            onClick={() => handleClickFilter("abertas")}
            className={classes.nested}
          >
            <ListItemText primary="Abertas" />
          </ListItemLink>

          <ListItemLink
            button
            onClick={() => handleClickFilter("homologadas")}
            className={classes.nested}
          >
            <ListItemText primary="Homologadas" />
          </ListItemLink>

          <ListItemLink
            button
            onClick={() => handleClickFilter("neighborhood")}
            className={classes.nested}
          >
            <ListItemText primary="Por Bairro" />
          </ListItemLink>

          <ListItemLink
            button
            onClick={() => handleClickFilter("service")}
            className={classes.nested}
          >
            <ListItemText primary="Por Serviço de Destino" />
          </ListItemLink>

          <ListItemLink
            button
            onClick={() => handleClickFilter("area")}
            className={classes.nested}
          >
            <ListItemText primary="Por Área da Ocorrência" />
          </ListItemLink>

          <ListItemLink
            button
            onClick={() => handleClickFilter("executor")}
            className={classes.nested}
          >
            <ListItemText primary="Por Executor Responsável" />
          </ListItemLink>

          <ListItemLink
            button
            onClick={() => handleClickFilter("controlador")}
            className={classes.nested}
          >
            <ListItemText primary="Por Controlador Responsável" />
          </ListItemLink>

          <ListItemLink
            button
            onClick={() => handleClickFilter("tempoAtendimento")}
            className={classes.nested}
          >
            <ListItemText primary="Tempo de Atendimento" />
          </ListItemLink>

          <ListItemLink
            button
            onClick={() => handleClickFilter("tempoResolucao")}
            className={classes.nested}
          >
            <ListItemText primary="Tempo de Resolução" />
          </ListItemLink>
        </List>
      </Collapse>

      <ListItem button onClick={handleClickGerenciamento}>
        <ListItemText
          primary={
            <Item
              width={24}
              height={20}
              Icon={RegistersIcon}
              text="Cadastros"
            />
          }
        />
        {renderIconExpand(openGerenciamento)}
      </ListItem>

      <Collapse in={openGerenciamento} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemLink
            button
            onClick={() => {
              redirectTo("/userregister");
            }}
            className={classes.nested}
          >
            <ListItemText primary="Cadastro de Usuários" />
          </ListItemLink>

          <ListItemLink
            button
            onClick={() => {
              redirectTo("/categoryregister");
            }}
            className={classes.nested}
          >
            <ListItemText primary="Cadastro de Tipos" />
          </ListItemLink>

          <ListItemLink
            button
            onClick={() => {
              redirectTo("/groupregister");
            }}
            className={classes.nested}
          >
            <ListItemText primary="Cadastro de Grupos" />
          </ListItemLink>

          <ListItemLink
            button
            onClick={() => {
              redirectTo("/interruptionregister");
            }}
            className={classes.nested}
          >
            <ListItemText primary="Cadastro de Interrupções" />
          </ListItemLink>

          <ListItemLink
            button
            onClick={() => {
              redirectTo("/statusregister");
            }}
            className={classes.nested}
          >
            <ListItemText primary="Cadastro de Status" />
          </ListItemLink>

          {userPermission === "admin" ? (
            <ListItemLink
              button
              onClick={() => {
                redirectTo("/materialregister");
              }}
              className={classes.nested}
            >
              <ListItemText primary="Cadastro de Materiais" />
            </ListItemLink>
          ) : null}
        </List>
      </Collapse>

      <ListItem button onClick={handleClickLogs}>
        <ListItemText
          primary={
            <Item width={24} height={20} Icon={HistoryIcon} text="Logs" />
          }
        />
        {renderIconExpand(openGerenciamento)}
      </ListItem>

      <Collapse in={openLogs} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemLink
            button
            onClick={() => {
              redirectTo("/list-operations");
            }}
            className={classes.nested}
          >
            <ListItemText primary="Todos" />
          </ListItemLink>

          <ListItemLink
            button
            onClick={() => {
              redirectTo("/no-location-complaints");
            }}
            className={classes.nested}
          >
            <ListItemText primary="Por Usuário" />
          </ListItemLink>

          <ListItemLink
            button
            onClick={() => {
              redirectTo("/late-complaints");
            }}
            className={classes.nested}
          >
            <ListItemText primary="Por Operação" />
          </ListItemLink>

          <ListItemLink
            button
            onClick={() => {
              redirectTo("/resolved-complaints");
            }}
            className={classes.nested}
          >
            <ListItemText primary="Por módulo" />
          </ListItemLink>

          <ListItemLink
            button
            onClick={() => {
              redirectTo("/resolved-complaints");
            }}
            className={classes.nested}
          >
            <ListItemText primary="Análises" />
          </ListItemLink>
        </List>
      </Collapse>

      <ListItemLink button id="manual-button">
        <ListItemText
          primary={
            <Item width={21} height={26} Icon={ManualIcon} text="Manual" />
          }
        />
      </ListItemLink>

      <ListItemLink
        button
        onClick={() => {
          redirectTo("/about");
        }}
      >
        <ListItemText
          primary={
            <Item width={18} height={24} Icon={AboutIcon} text="Sobre" />
          }
        />
      </ListItemLink>
    </div>
  );
}
